import { render, staticRenderFns } from "./ImporterECF.vue?vue&type=template&id=6399cb2b&scoped=true"
import script from "./ImporterECF.vue?vue&type=script&lang=js"
export * from "./ImporterECF.vue?vue&type=script&lang=js"
import style0 from "./ImporterECF.vue?vue&type=style&index=0&id=6399cb2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6399cb2b",
  null
  
)

export default component.exports